import { USER_CHANNEL_LAST_UPDATE, USER_CHANNEL_UNSEEN_COUNT, USER_CHANNELS, UserChannel } from "../../db/chat";
import { DatabaseTimestampServerValue, RealtimeReference } from "../../db/common";
import { BaseTwoLayerDatabaseService } from "../DatabaseService";

/**
 * Shared Chat Message Service
 * Works with both Firebase Admin SDK (backend) and Client SDK (frontend)
 */
export class UserChannelService extends BaseTwoLayerDatabaseService<UserChannel> {
    protected getBasePath(): string {
        return USER_CHANNELS;
    }

    //make it public for sub on change for FE
    public getParentRef(userId: string): RealtimeReference {
        return super.getParentRef(userId)
    }
    public getChildRef(userId: string, channelId: string): RealtimeReference {
        return super.getChildRef(userId, channelId);
    }

    // @overwrite
    create(
        userId: string,
        userChannel?: Omit<UserChannel, typeof USER_CHANNEL_LAST_UPDATE | typeof USER_CHANNEL_UNSEEN_COUNT>,
        channelId?: string,
    ): Promise<string> {
        return super.create(
            userId,
            {
                [USER_CHANNEL_LAST_UPDATE]: DatabaseTimestampServerValue,
                [USER_CHANNEL_UNSEEN_COUNT]: 0,
                ...userChannel
            } as UserChannel,
            channelId);
    }

    // @overwrite
    update(userId: string, channelId: string, data: Partial<UserChannel>): Promise<void> {
        return super.update(
            userId,
            channelId,
            data,
        )
    }
}
